import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { codeEditorChange } from 'actions/template'
import AceEditor from 'react-ace'
import pretty from 'pretty'
import 'brace/mode/html'
import 'brace/theme/monokai'

export default connect(
  (state) => ({
    value:
      (typeof state.email.sectionSelected === 'number' &&
        state.email.sections[state.email.sectionSelected] &&
        state.email.sections[state.email.sectionSelected].value) ||
      '',
  }),
  (dispatch) => bindActionCreators({ codeEditorChange }, dispatch),
)(({ codeEditorChange, value, height }) => (
  <AceEditor
    className="ignore-react-onclickoutside"
    width="100%"
    mode="html"
    theme="monokai"
    name="blah2"
    onChange={codeEditorChange}
    fontSize={12}
    showPrintMargin={true}
    wrapEnabled={true}
    showGutter={true}
    highlightActiveLine={true}
    value={pretty(value)}
    setOptions={{
      showLineNumbers: true,
      tabSize: 2,
    }}
    debounceChangePeriod={1500}
    height={height}
  />
))
